// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsurancePolicyDetailsPremiumPaymentSourceOptions_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CLTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CRTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GRATTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'ILITTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'PrivateFoundation', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QPRTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SLATTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } };

export type InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables = Types.Exact<{
  entityWhereInput: Types.EntityWhereInput;
  skipQuery: Types.Scalars['Boolean']['input'];
  entityId: Types.Scalars['ID']['input'];
  loadEntity: Types.Scalars['Boolean']['input'];
}>;


export type InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery = { __typename?: 'Query', currentEntity?: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & InsurancePolicyDetailsPremiumPaymentSourceOptions_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    InsurancePolicyDetailsPremiumPaymentSourceOptions: 'InsurancePolicyDetailsPremiumPaymentSourceOptions' as const
  },
  Fragment: {
    InsurancePolicyDetailsPremiumPaymentSourceOptions_Entity: 'InsurancePolicyDetailsPremiumPaymentSourceOptions_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const InsurancePolicyDetailsPremiumPaymentSourceOptions_EntityFragmentDoc = gql`
    fragment InsurancePolicyDetailsPremiumPaymentSourceOptions_Entity on Entity {
  id
  kind
  subtype {
    id
    displayName
    currentValue
  }
}
    `;
export const InsurancePolicyDetailsPremiumPaymentSourceOptionsDocument = gql`
    query InsurancePolicyDetailsPremiumPaymentSourceOptions($entityWhereInput: EntityWhereInput!, $skipQuery: Boolean!, $entityId: ID!, $loadEntity: Boolean!) {
  currentEntity: entities(where: {id: $entityId}) @skip(if: $skipQuery) @include(if: $loadEntity) {
    edges {
      node {
        id
        subtype {
          id
          displayName
        }
      }
    }
  }
  entities(where: $entityWhereInput) {
    edges {
      node {
        ...InsurancePolicyDetailsPremiumPaymentSourceOptions_Entity
      }
    }
  }
}
    ${InsurancePolicyDetailsPremiumPaymentSourceOptions_EntityFragmentDoc}`;

/**
 * __useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery__
 *
 * To run a query within a React component, call `useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery({
 *   variables: {
 *      entityWhereInput: // value for 'entityWhereInput'
 *      skipQuery: // value for 'skipQuery'
 *      entityId: // value for 'entityId'
 *      loadEntity: // value for 'loadEntity'
 *   },
 * });
 */
export function useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery(baseOptions: Apollo.QueryHookOptions<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>(InsurancePolicyDetailsPremiumPaymentSourceOptionsDocument, withFetchPolicyContext(options));
      }
export function useInsurancePolicyDetailsPremiumPaymentSourceOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>(InsurancePolicyDetailsPremiumPaymentSourceOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useInsurancePolicyDetailsPremiumPaymentSourceOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>(InsurancePolicyDetailsPremiumPaymentSourceOptionsDocument, withFetchPolicyContext(options));
        }
export type InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryHookResult = ReturnType<typeof useInsurancePolicyDetailsPremiumPaymentSourceOptionsQuery>;
export type InsurancePolicyDetailsPremiumPaymentSourceOptionsLazyQueryHookResult = ReturnType<typeof useInsurancePolicyDetailsPremiumPaymentSourceOptionsLazyQuery>;
export type InsurancePolicyDetailsPremiumPaymentSourceOptionsSuspenseQueryHookResult = ReturnType<typeof useInsurancePolicyDetailsPremiumPaymentSourceOptionsSuspenseQuery>;
export type InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryResult = Apollo.QueryResult<InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery, InsurancePolicyDetailsPremiumPaymentSourceOptionsQueryVariables>;